(() => {
  const dialog = document.querySelector('[data-newsletter-dialog]');
  if (!dialog || typeof dialog.show !== 'function') return;
  const dismissedKey = 'lh-society-dismissed-v1';
  const subscribedKey = 'lh-society-subscribed-v1';
  let returnFocus;
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { try { localStorage.setItem(key, value); } catch {} };
  const remember = () => write(dismissedKey, String(Date.now()));
  const open = (manual = false) => {
    if (dialog.open) return;
    returnFocus = document.activeElement;
    dialog.show();
    if (manual) {
      const target = dialog.querySelector('[data-newsletter-success], [data-newsletter-error], input[type=email]');
      target?.focus({ preventScroll: true });
    } else if (returnFocus && returnFocus.isConnected) {
      returnFocus.focus({ preventScroll: true });
    }
  };
  const close = () => {
    const hadFocus = dialog.contains(document.activeElement);
    remember();
    dialog.close();
    if (hadFocus && returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  };
  document.querySelectorAll('[data-newsletter-open]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); open(true); }));
  dialog.querySelector('[data-newsletter-close]')?.addEventListener('click', close);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && dialog.open) { event.preventDefault(); close(); }
  });
  const success = dialog.querySelector('[data-newsletter-success]');
  const error = dialog.querySelector('[data-newsletter-error]');
  if (success || error) {
    if (success) { write(subscribedKey, 'true'); remember(); }
    open(true);
    return;
  }
  if (dialog.dataset.societyAuto !== 'true' || read(subscribedKey) === 'true' || window.Shopify?.designMode) return;
  const lastDismissed = Number(read(dismissedKey) || read('lh-newsletter-dismissed') || 0);
  if (Number.isFinite(lastDismissed) && Date.now() - lastDismissed < 30 * 86400000) return;
  let attempts = 0;
  const showWhenIdle = () => {
    if (read(subscribedKey) === 'true') return;
    if (document.hidden || document.activeElement?.matches('input, textarea, select') || document.querySelector('dialog[open]')) {
      if (++attempts < 12) window.setTimeout(showWhenIdle, 5000);
      return;
    }
    open();
  };
  const engagementKey = 'lh-society-seen-session';
  let sessionSeen = false;
  try { sessionSeen = sessionStorage.getItem(engagementKey) === 'true'; } catch {}
  if (sessionSeen) return;
  const started = Date.now();
  let triggered = false;
  const consider = () => {
    if (triggered || Date.now() - started < 30000) return;
    const distance = document.documentElement.scrollHeight - innerHeight;
    if (distance > 0 && scrollY / distance < 0.4) return;
    triggered = true;
    try { sessionStorage.setItem(engagementKey, 'true'); } catch {}
    removeEventListener('scroll', consider);
    showWhenIdle();
  };
  addEventListener('scroll', consider, {passive:true});
  setTimeout(consider, 30000);
})();




